import { Button } from '@pets-ui/Button/Button'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  startIcon: {
    fontSize: '20px',
    position: 'absolute',
    height: '20px',
    left: '16px',
    width: '20px',
  },
  button: {
    textTransform: 'none',
  },
})

interface ButtonThirtyPartyLoginProps {
  onClick?: () => void
  children: ReactNode
  icon: ReactNode
}

export function ButtonThirtyPartyLogin(props: ButtonThirtyPartyLoginProps) {
  const { onClick, children, icon } = props
  return (
    <Button
      fullWidth
      variant="outlined"
      color="grey"
      startIcon={icon}
      xStyles={{
        startIcon: styles.startIcon,
        root: styles.button,
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}
